module.exports = __webpack_public_path__ + "static/media/photopea.0efc47e2.png";